//# sourceMappingURL=navbar_styles.mjs.map
/// <reference types="./navbar_styles.d.mts" />
import * as $colors from "../../ds/ds/colors.mjs";
import * as $button from "../../ds/ds/components/button.mjs";
import * as $text from "../../ds/ds/typography/text.mjs";
import * as $attribute from "../../redraw_dom/redraw/dom/attribute.mjs";
import * as $css from "../../sketch/sketch/css.mjs";
import * as $length from "../../sketch/sketch/css/length.mjs";
import { percent, px } from "../../sketch/sketch/css/length.mjs";
import * as $h from "../../sketch_redraw/sketch/redraw/dom/html.mjs";
import { toList, prepend as listPrepend } from "../gleam.mjs";

export function navbar(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.padding(px(20)),
      $css.max_width(px(300)),
      $css.background($colors.light.grey_100),
      $css.gap(px(60)),
      $css.flex_direction("column"),
      $css.overflow("auto"),
      $css.z_index(90_005),
      $css.transition("width .6s"),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function logo_style() {
  return $css.class$(
    toList([
      $css.display("flex"),
      $css.max_height(px(35)),
      $css.gap(px(14)),
      $css.width(percent(100)),
    ]),
  );
}

export function logo(attrs, children) {
  let _pipe = $css.class$(toList([$css.compose(logo_style())]));
  return $h.div(_pipe, attrs, children);
}

export function logo_text(attrs, children) {
  let _pipe = $css.class$(toList([$css.padding_("7px 0"), $css.flex("1")]));
  return $h.div(_pipe, attrs, children);
}

export function navbar_main(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("column"),
      $css.gap(px(8)),
      $css.flex("1"),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function nav_links(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("column"),
      $css.gap(px(4)),
      $css.padding_top(px(24)),
      $css.flex("1"),
    ]),
  );
  return $h.nav(_pipe, attrs, children);
}

export function nav_link(active, attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.sm($text.medium)),
      $css.display("flex"),
      $css.flex_direction("row"),
      $css.align_items("center"),
      $css.gap(px(12)),
      $css.border_radius(px(8)),
      $css.color($colors.light.text_display),
      $css.text_decoration("none"),
      $css.padding_("9px 12px"),
      $css.transition("all .3s"),
      $css.background(
        (() => {
          if (active) {
            return $colors.light.grey_200;
          } else {
            return $colors.light.transparent;
          }
        })(),
      ),
      $css.hover(
        (() => {
          if (active) {
            return toList([]);
          } else {
            return toList([$css.background($colors.light.text_white)]);
          }
        })(),
      ),
    ]),
  );
  return $h.a(_pipe, attrs, children);
}

export function nav_section(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.sm($text.medium)),
      $css.padding_top(px(9)),
      $css.padding_bottom(px(4)),
      $css.padding_right(px(9)),
      $css.padding_left(px(9)),
      $css.color($colors.palette.grey_800),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function nav_section_title(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.sm($text.medium)),
      $css.padding_top(px(9)),
      $css.padding_bottom(px(6)),
      $css.color($colors.palette.grey_800),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function navbar_settings(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("column"),
      $css.gap(px(32)),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function user_section(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("row"),
      $css.justify_content("space-between"),
      $css.align_items("center"),
      $css.background($colors.palette.grey_200),
      $css.padding_("9px 12px"),
      $css.border_radius(px(16)),
      $css.gap(px(24)),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function user_name(attrs, children) {
  let _pipe = $css.class$(toList([$css.compose($text.sm($text.medium))]));
  return $h.div(_pipe, attrs, children);
}

export function user_email(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.xs($text.medium)),
      $css.color($colors.palette.grey_800),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function user_logout(attrs, children) {
  return $button.secondary(
    listPrepend(
      $attribute.style(
        toList([
          ["width", "36px"],
          ["height", "36px"],
          ["padding", "0"],
          ["border-radius", "24px"],
        ]),
      ),
      attrs,
    ),
    children,
  );
}

export function selected_organization(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.xs($text.medium)),
      $css.color($colors.palette.grey_800),
      $css.font_weight("600"),
      $css.padding_left(px(6)),
      $css.padding_top(px(4)),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}
